import React from 'react';

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

import classes from './SidebarLogoSection.module.scss';
import { SwymoLogo } from '../../../components/SwymoLogo/SwymoLogo';
import { useSidebarContext } from '../hooks/SidebarContext';

const SidebarLogoSection = () => {
  const { isCollapsed, toggleCollapsed } = useSidebarContext();

  return (
    <div className={classes.box}>
      {!isCollapsed && <SwymoLogo className={classes.logo} />}
      <button
        onClick={toggleCollapsed}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        className={classes.collapseButton}
        type="button"
      >
        {isCollapsed ? (
          <KeyboardArrowRightRoundedIcon fontSize="medium" />
        ) : (
          <ChevronLeftRoundedIcon fontSize="medium" />
        )}
      </button>
    </div>
  );
};

export { SidebarLogoSection };
